import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.5 3.75C18.9248 3.75 21 5.73974 21 8.75C21 11.8631 19.3377 14.3683 17.252 16.335C15.4151 18.0669 13.3471 19.2916 12 20.0869C10.6529 19.2916 8.58492 18.0669 6.74805 16.335C4.66226 14.3683 3 11.8631 3 8.75C3 5.74431 5.10853 3.75 7.5 3.75C9.01229 3.75 10.4128 4.57686 11.293 5.45703L12 6.16406L12.707 5.45703C13.5872 4.57685 14.9877 3.75 16.5 3.75Z",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }